import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import AbsenceReasonEditor from "../../editors/personInfo/absenceReason";

const AbsenceReasons: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.AbsenceReasonsList}
			endpoint={Endpoint.AbsenceReasons}
			addScreen={{ screen: AbsenceReasonEditor, isAllowed: hasPermission(Permission.AbsenceReasonsAdd) }}
			editScreen={{ screen: AbsenceReasonEditor, isAllowed: hasPermission(Permission.AbsenceReasonsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.AbsenceReasonsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="countAsPresent" title={t("countAsPresent")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default AbsenceReasons;
